<app-accordion [elementId]="subGroup.id"
               [prefixId]=" prefixId"
               [isDeletable]="subGroup.deletable"
               [elementLabel]="subGroup._label"
               [isRepeatable]="subGroup._repeatable"
               [infoBulle]="subGroup.infoBulle"
               [groupType]="getGroupType(subGroup.id)"
               (addSomething)="addSubGroup()"
               (deleteSomething)="removeSubGroup()">
<p class="messageInfo">
  {{parcoursUtilisateur(subGroup)}}
              </p>
  <div *ngFor="let field of subGroup.fields; let i = index">
    <app-form-input [prefixId]="prefixId" [parentForm]="formGroup"
                    [field]="field" [subSectionId]="subSectionId"
                    [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
                    [sharedPath]="subGroup.jsonPath"
                    [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                    [noticeValue]="noticeValue" (preferenceSelected)="emitDonneePreference($event)"
                    [groupOrSectionId]="subGroup.id" (newField)="newField($event)"
                    (deleteField)="deleteField($event)" [index]="index"></app-form-input>
  </div>
  <div *ngFor="let subSubGroup of subGroup.subSubGroups; let i = index">
    <app-sub-sub-group
      *ngIf="!subSubGroup?.hidden" [prefixId]="prefixId"
      [formGroup]="formGroup" [subSectionId]="subSectionId"
      [subSubGroup]="subSubGroup" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
      (newSubSubGroup)="newSubSubGroup($event)"
      (deleteSubSubGroup)="deleteSubSubGroup($event)"
      [repeatablePath]="repeatablePath" [parentsChild]="subGroup.subSubGroups"
      [repeatablePathWithIndex]="getRepeatablePathWithIndexForSubSubGroup(subSubGroup)"
      [noticeValue]="noticeValue" [linkForRouter]="linkForRouter" [index]="index">
    </app-sub-sub-group>
  </div>
</app-accordion>
